export default __webpack_public_path__ + "static/media/placeholder_private01-nl-web.4d441b41.png";